import React from 'react';

const renderFileUpload = ({ input, label, type, meta: { touched, error }, ...props }) => {
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    
    // Validar que sea una imagen JPG o PNG
    if (file) {
      const validTypes = ['image/jpeg', 'image/png'];
      const isValidType = validTypes.includes(file.type);
      
      if (!isValidType) {
        alert('Por favor, selecciona solo archivos JPG o PNG');
        e.target.value = ''; // Limpiar el input
        return;
      }
    }
    
    // Guardar el archivo en el estado de redux-form
    input.onChange(file);
  };

  return (
    <div>
      <input
        {...props}
        type="file"
        accept="image/jpeg,image/png"
        onChange={handleFileChange}
        className="form-control"
      />
      {touched && error && <span className="text-danger">{error}</span>}
    </div>
  );
};

export default renderFileUpload;